<ion-content forceOverscroll="false">
  <app-header [fixedTitle]="true">
    <app-toolbar [title]="title">
      <app-toolbar-button [text]="'lbl_go_back' | translate" slot="start" (click)="closeModal()"></app-toolbar-button>
    </app-toolbar>
  </app-header>

  <main hasFooter>
    <ion-list>
      @for (tag of tagsList; track tag) {
        <app-item lines="full" [detailIcon]="false"
          (click)="selectTag(tag, $event)">
          <div class="item-checkbox" [class.checked]="isTagChecked(tag)" [class.disabled]="isConfirmed && !tag.enabled">
            <span class="checkbox-container">
              <span class="checkbox-control">
                <ion-icon name="checkmark-outline"></ion-icon>
              </span>
            </span>
            <span class="checkbox-label">
              <span class="tag-color" [style]="{ backgroundColor: tag.color }">
              </span>
              <span class="tag-description">
                {{ tag.description }}
              </span>
            </span>
          </div>
        </app-item>
      }
    </ion-list>
  </main>
</ion-content>
